import { createLombokApiClient, type TokenProvider } from '@lombok/api-client';
import { env } from '@/config/env';

/**
 * The single API client instance for the app. The bearer token is injected
 * lazily via `getToken()` so this module has no dependency on the auth layer
 * and no token is ever read from storage by the client itself.
 *
 * The auth layer registers the real token getter at startup via
 * `setTokenProvider`. The provider may be async so it can refresh an expired
 * Cognito token before a request goes out. Until registered (or when signed
 * out) requests go out unauthenticated and the backend rejects protected
 * routes with 401.
 */
let tokenProvider: TokenProvider = () => null;

/** Registered by the auth layer; returns the current bearer token or null (may be async). */
export function setTokenProvider(provider: TokenProvider): void {
  tokenProvider = provider;
}

const { client, api } = createLombokApiClient({
  baseUrl: env.apiBaseUrl,
  getToken: () => tokenProvider(),
});

export { client, api };
